/*
 * @created: Wednesday, 1st April 2020 2:49:29 pm
 * @author: github.com/huangbinjie
 * @file: 橘红色
 *
 * Copyright 2020 Qiniu
 */
var OrangeRed;
(function (OrangeRed) {
    OrangeRed["orangeRed1"] = "#FDBE94";
    OrangeRed["orangeRed2"] = "#FDAC7D";
    OrangeRed["orangeRed3"] = "#FC9966";
    OrangeRed["orangeRed4"] = "#FB834D";
    OrangeRed["orangeRed5"] = "#FA6C34";
    OrangeRed["orangeRed6"] = "#FA541C";
    OrangeRed["orangeRed7"] = "#DF4316";
    OrangeRed["orangeRed8"] = "#C73511";
    OrangeRed["orangeRed9"] = "#AD280D";
    OrangeRed["orangeRed10"] = "#941E09";
})(OrangeRed || (OrangeRed = {}));
export default OrangeRed;
//# sourceMappingURL=orange-red.js.map